import { FormFields } from 'hooks';
import { validateName } from '@utils';

export type NameFormFieldNames = 'firstName' | 'lastName';

export const getFormFields = (initialFirstName?: string, initialLastName?: string): FormFields<NameFormFieldNames> => ({
  firstName: {
    name: 'firstName',
    initialValue: initialFirstName ?? '',
    isRequired: true,
    validate: validateName,
    requiredMessage: 'First name is required'
  },
  lastName: {
    name: 'lastName',
    initialValue: initialLastName ?? '',
    isRequired: true,
    validate: validateName,
    requiredMessage: 'Last name is required'
  }
});
